import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import {
  IonIcon,
  IonSearchbar,
  IonModal,
  IonLabel,
  IonToolbar,
  IonFooter,
  IonContent,
  IonItem,
  IonCheckbox,
  IonList,
  IonAccordionGroup,
  IonAccordion,
  isPlatform,
  IonHeader,
  IonTitle,
} from "@ionic/react";
import { useIntl } from "react-intl";
import { closeCircle } from "ionicons/icons";
import classNames from "classnames";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { IconTrash } from "@tabler/icons-react";
import useContactsStore from "../../../store/contacts";
import styles from "./styles.module.css";
import { Nav } from "react-bootstrap";
import { Company, FilterOption, Assignation } from "../../../interfaces";
import useCountersStore from "../../../store/counts";
import AssignationApi from "../../../api/assignation";

//styles
import modalStyles from "../../../theme/modal.module.css";
const isMobile = isPlatform("android") || isPlatform("ios");
interface Action {
  name: string;
  id: string;
}
const DropdownCheckbox: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const [path, setPath] = useState<string>(location.pathname.split("/")[1]);
  const [showPopover, setShowPopover] = useState(false);
  const [users, setUsers] = useState<Assignation[]>([]);

  const filters = useContactsStore((state) => state.filters);
  const setFilters = useContactsStore((state) => state.setFilters);
  const availableActions = useContactsStore((state) => state.availableActions);

  const [draftFilters, setDraftFilters] = useState<FilterOption[]>(filters);
  const accordionGroup = useRef<null | HTMLIonAccordionGroupElement>(null);
  const intl = useIntl();

  const fetchUsers = async () => {
    try {
      const { data } = await AssignationApi.getListOfUsers();
      if (data) {
        setUsers(data.users);
      }
    } catch (e) {
      console.error("Error fetching users", e);
    }
  };

  useEffect(() => {
    if (showPopover) {
      setDraftFilters(filters);
    }
  }, [showPopover, filters]);

  useEffect(() => {
    if (!accordionGroup.current) {
      return;
    }
    accordionGroup.current.value = ["first"];
  }, []);

  const autoOpenAccordion = () => {
    if (!accordionGroup.current) {
      return;
    }
    accordionGroup.current.value = ["first"];
  };

  useEffect(() => {
    try {
      // get first part of the path
      const currentPath = location.pathname.split("/")[1];
      const previousPath = path;
      if (currentPath !== previousPath && previousPath !== "") {
        const updatedFilters = filters.map((filter) => ({
          ...filter,
          isActive: false,
          value: filter.type === "list" ? [] : filter.value,
        }));
        setPath(currentPath);
        setFilters(updatedFilters);
        setDraftFilters(updatedFilters);
      }
    } catch (e) {}
  }, [location.pathname]);

  const onRemoveAllFilters = () => {
    const updated = filters.map((filter) => ({
      ...filter,
      isActive: filter.label === "bucket" ? filter.isActive : false,
      value: filter.type === "list" ? [] : filter.value,
    }));
    setFilters(updated);
  };

  const onApply = () => {
    setFilters(draftFilters);
    setShowPopover(false);
  };

  const onFilterChange = ({
    label,
    checked,
    value,
  }: {
    label: string;
    checked: boolean;
    value?: boolean | string;
  }) => {
    const updated = draftFilters.map((filter) => {
      if (filter.label === label) {
        const updatedValue =
          filter.type === "list"
            ? checked
              ? [...(filter.value as string[]), value as string]
              : (filter.value as string[]).filter((v) => v !== value)
            : filter.value;

        return {
          ...filter,
          isActive:
            checked ||
            (filter.type === "list" && (updatedValue as string[]).length > 0),
          value: updatedValue,
        };
      }
      return filter;
    });
    setDraftFilters(updated);
  };

  // Do not count search or bucket filters
  const howMany = filters.filter(
    (f) => f.isActive && ["search", "bucket"].indexOf(f.label) === -1
  ).length;

  const areFiltersActive = filters.some(
    (f) => f.isActive && ["search", "bucket"].indexOf(f.label) === -1
  );

  const activeStatusCount = draftFilters.filter(
    (f) => f.isVisible !== false && f.isActive
  ).length;

  const activeActionsCount = (
    (draftFilters.find((f) => f.label === "actions")?.value as string[]) || []
  ).length;

  const activeCompaniesCount = (
    (draftFilters.find((f) => f.label === "companies")?.value as string[]) || []
  ).length;

  const activeQualityCount = (
    (draftFilters.find((f) => f.label === "quality")?.value as string[]) || []
  ).length;

  const activeUsersCount = (
    (draftFilters.find((f) => f.label === "users")?.value as string[]) || []
  ).length;

  const countSuffix = (n: number) => (n > 0 ? ` (${n})` : "");

  return (
    <>
      <div className={styles.btnNavigation}>
        {!isMobile ? (
          <div className={styles.btnNavigation}>
            <button
              className={`btn btn-xs btn-ionic-light btn-flex ${styles.btnHeader}`}
              onClick={() => {
                setShowPopover(true);
                autoOpenAccordion();
                fetchUsers();
              }}
            >
              <div className={styles.btnImageFilter}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={14}
                  height={14}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--ion-color-step-750)"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 6h16" />
                  <path d="M6 12h12" />
                  <path d="M9 18h6" />
                </svg>
              </div>
              <div>
                <div className="d-flex">
                  <FormattedMessage id={`chats.filter`} />
                  {areFiltersActive ? (
                    <div style={{ marginLeft: "3px" }}>
                      <div className="badge color-visito-1-bg">{howMany}</div>
                    </div>
                  ) : null}
                </div>
              </div>
            </button>
          </div>
        ) : (
          <button
            onClick={() => {
              setShowPopover(true);
              autoOpenAccordion();
              fetchUsers();
            }}
            className="no-bg btn-flex"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={23}
              height={23}
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--visito-color-1)"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M4 6h16" />
              <path d="M6 12h12" />
              <path d="M9 18h6" />
            </svg>
            {areFiltersActive ? (
              <div style={{ marginLeft: "3px" }}>
                <div className="badge color-visito-1-bg">{howMany}</div>
              </div>
            ) : null}
          </button>
        )}
      </div>
      <IonModal
        isOpen={showPopover}
        onDidDismiss={() => setShowPopover(false)}
        onDidPresent={autoOpenAccordion}
      >
        <IonContent className="ion-padding">
          <IonHeader>
            <IonToolbar>
              <IonTitle>
                <FormattedMessage id="common.filterConvs" />
              </IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonAccordionGroup ref={accordionGroup}>
            <IonAccordion value="first">
              <IonItem slot="header" color="light">
                <IonLabel className="fs-2 color-step-900">{`Status${countSuffix(
                  activeStatusCount
                )}`}</IonLabel>
              </IonItem>
              <div className="ion-padding" slot="content">
                <IonList lines="full" className="p-0">
                  {draftFilters
                    .filter((o: FilterOption) => o.isVisible !== false)
                    .map((option: FilterOption) => (
                      <IonItem key={option.label} button detail={false}>
                        <IonCheckbox
                          justify="space-between"
                          color="success"
                          id={option.label}
                          checked={option.isActive}
                          onIonChange={(e) =>
                            onFilterChange({
                              label: e.target.id,
                              checked: e.target.checked,
                            })
                          }
                        >
                          <span className="fs-3 color-step-900 mb-0">
                            <FormattedMessage id={`chats.${option.label}`} />
                          </span>
                          <p className="fs-2 mb-0 color-step-600">
                            <FormattedMessage
                              id={`chats.${option.label}.explanation`}
                            />
                          </p>
                        </IonCheckbox>
                      </IonItem>
                    ))}
                </IonList>
              </div>
            </IonAccordion>
            {availableActions.length > 0 && (
              <IonAccordion value="second">
                <IonItem slot="header" color="light" button detail={false}>
                  <IonLabel className="fs-3 color-step-900">
                    {`${intl.formatMessage({
                      id: "leads.filter.actions",
                    })}${countSuffix(activeActionsCount)}`}
                  </IonLabel>
                </IonItem>
                <div className="ion-padding" slot="content">
                  <IonList lines="full" className="p-0">
                    {availableActions?.map((action: string) => (
                      <IonItem key={action} button>
                        <IonCheckbox
                          justify="space-between"
                          color="success"
                          id={action}
                          checked={
                            (
                              draftFilters.find((f) => f.label === "actions")
                                ?.value as string[]
                            )?.includes(action) || false
                          }
                          onIonChange={(e) =>
                            onFilterChange({
                              label: "actions",
                              value: action,
                              checked: e.target.checked,
                            })
                          }
                        >
                          <span className="fs-3 color-step-900">
                            <FormattedMessage id={`leads.stats.${action}`} />
                          </span>
                          <p className="fs-2 mb-0 color-step-600">
                            <FormattedMessage
                              id={`leads.stats.${action}Explanation`}
                            />
                          </p>
                        </IonCheckbox>
                      </IonItem>
                    ))}
                  </IonList>
                </div>
              </IonAccordion>
            )}
            {props.companies && props.companies.length > 1 && (
              <IonAccordion value="chats.accounts">
                <IonItem slot="header" color="light">
                  <IonLabel className="fs-3 color-step-900">
                    {`${intl.formatMessage({
                      id: "chats.accounts",
                    })}${countSuffix(activeCompaniesCount)}`}
                  </IonLabel>
                </IonItem>
                <div className="ion-padding" slot="content">
                  <IonList lines="full" className="p-0">
                    {props.companies?.map((company: Company) => (
                      <IonItem key={company.id} button detail={false}>
                        <IonCheckbox
                          justify="space-between"
                          color="success"
                          id={company.id}
                          checked={
                            (
                              draftFilters.find((f) => f.label === "companies")
                                ?.value as string[]
                            )?.includes(company.id) || false
                          }
                          onIonChange={(e) =>
                            onFilterChange({
                              label: "companies",
                              value: company.id,
                              checked: e.target.checked,
                            })
                          }
                        >
                          <span className="fs-3 color-step-900">
                            {company.name || "No name"}
                          </span>
                        </IonCheckbox>
                      </IonItem>
                    ))}
                  </IonList>
                </div>
              </IonAccordion>
            )}

            {users && users.length > 1 && (
              <IonAccordion value="chats.assignation">
                <IonItem slot="header" color="light">
                  <IonLabel className="fs-3 color-step-900">
                    {`${intl.formatMessage({
                      id: "chats.assignation",
                    })}${countSuffix(activeUsersCount)}`}
                  </IonLabel>
                </IonItem>
                <div className="ion-padding" slot="content">
                  <IonList lines="full" className="p-0">
                    {users.map((user: Assignation) => (
                      <IonItem key={user.id} button detail={false}>
                        <IonCheckbox
                          justify="space-between"
                          color="success"
                          id={user.id}
                          checked={
                            (
                              draftFilters.find((f) => f.label === "users")
                                ?.value as string[]
                            )?.includes(user.id) || false
                          }
                          onIonChange={(e) =>
                            onFilterChange({
                              label: "users",
                              value: user.id,
                              checked: e.target.checked,
                            })
                          }
                        >
                          <span className="fs-2 color-step-900">
                            {user.email || "No name"}
                          </span>
                        </IonCheckbox>
                      </IonItem>
                    ))}
                  </IonList>
                </div>
              </IonAccordion>
            )}

            <IonAccordion value="fourth">
              <IonItem slot="header" color="light">
                <IonLabel className="fs-3 color-step-900">
                  {`${intl.formatMessage({ id: "leads.score" })}${countSuffix(
                    activeQualityCount
                  )}`}
                </IonLabel>
              </IonItem>
              <div className="ion-padding" slot="content">
                <IonList lines="full" className="p-0">
                  {["high", "medium", "low"].map((quality) => (
                    <IonItem key={quality} button>
                      <IonCheckbox
                        justify="space-between"
                        color="success"
                        id={quality}
                        checked={
                          (
                            draftFilters.find((f) => f.label === "quality")
                              ?.value as string[]
                          )?.includes(quality) || false
                        }
                        onIonChange={(e) =>
                          onFilterChange({
                            label: "quality",
                            value: quality,
                            checked: e.target.checked,
                          })
                        }
                      >
                        <span className="fs-3 color-step-900">
                          <FormattedMessage id={`leads.${quality}`} />
                        </span>
                      </IonCheckbox>
                    </IonItem>
                  ))}
                </IonList>
              </div>
            </IonAccordion>
          </IonAccordionGroup>
        </IonContent>
        <IonFooter>
          <IonToolbar style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div
              className={modalStyles.footer}
              style={{ borderTop: "0px", padding: "0.5rem 1em" }}
            >
              <button
                className="btn btn-visito-light w-100"
                onClick={() => setShowPopover(false)}
              >
                <FormattedMessage id="common.cancel" />
              </button>
              <button
                className="btn btn-visito-primary w-100"
                onClick={onApply}
              >
                <FormattedMessage id="common.apply" />
              </button>
            </div>
          </IonToolbar>
        </IonFooter>
      </IonModal>

      {areFiltersActive && !isMobile ? (
        <IonIcon
          style={{ opacity: "50%", marginLeft: "3px" }}
          icon={closeCircle}
          className="pointer"
          size="small"
          onClick={() => onRemoveAllFilters()}
        ></IonIcon>
      ) : null}
    </>
  );
};

export const ContactsBuckets: React.FC<{
  defaultClass?: string;
  fill?: boolean;
}> = (props) => {
  const setFilters = useContactsStore((state) => state.setFilters);
  const filters = useContactsStore((state) => state.filters);
  const total = useCountersStore((state) => state.total);

  const handleAssignation = (bucket: string) => {
    const updatedFilters = filters.map((filter) => {
      if (filter.label === "bucket") {
        return {
          ...filter,
          isActive: bucket !== "all",
          value: bucket !== "all" ? bucket : "",
        };
      }
      return filter;
    });
    setFilters(updatedFilters);
  };

  const pendingNavActive =
    filters.find((f) => f.label === "bucket")?.isActive &&
    filters.find((f) => f.label === "bucket")?.value === "pending";

  const mineNavActive =
    filters.find((f) => f.label === "bucket")?.isActive &&
    filters.find((f) => f.label === "bucket")?.value === "mine";

  const archivedNavActive =
    filters.find((f) => f.label === "bucket")?.isActive &&
    filters.find((f) => f.label === "bucket")?.value === "archived";

  return (
    <Nav fill={props.fill} className={props.defaultClass}>
      <Nav.Item>
        <Nav.Link
          active={!pendingNavActive && !archivedNavActive && !mineNavActive}
          onClick={() => handleAssignation("all")}
        >
          <FormattedMessage id="chats.bucket.all" />
        </Nav.Link>
      </Nav.Item>

      {/*
      <Nav.Item>
        <OverlayTrigger
          delay={{ show: 750, hide: 400 }}
          placement="bottom"
          overlay={
            <Tooltip className="visito-tooltip">
              <FormattedMessage id="chats.bucket.mine.explanation" />
            </Tooltip>
          }
        >
          <Nav.Link
            active={mineNavActive}
            onClick={() => handleAssignation("mine")}
          >
            <FormattedMessage id="chats.bucket.mine" />
          </Nav.Link>
        </OverlayTrigger>
      </Nav.Item>
*/}
      <Nav.Item>
        <OverlayTrigger
          delay={{ show: 750, hide: 400 }}
          placement="bottom"
          overlay={
            <Tooltip className="visito-tooltip">
              <FormattedMessage id="chats.bucket.pending.explanation" />
            </Tooltip>
          }
        >
          <Nav.Link
            active={pendingNavActive}
            onClick={() => handleAssignation("pending")}
          >
            <div className="d-flex align-items-center justify-content-center gap-2">
              <div className="d-flex align-items-center gap-1">
                <FormattedMessage id="chats.bucket.pending" />
                {total > 0 && (
                  <span className="notif-pill btn-visito-danger rounded-pill fw-bold">
                    {total > 99 ? "99+" : total}
                  </span>
                )}
              </div>
            </div>
          </Nav.Link>
        </OverlayTrigger>
      </Nav.Item>
    </Nav>
  );
};

export const SearchContacts: React.FC<{}> = (props) => {
  const intl = useIntl();
  const searchbarRef = useRef<HTMLIonSearchbarElement>(null);
  const filters = useContactsStore((state) => state.filters);
  const setFilters = useContactsStore((state) => state.setFilters);
  const searchActive = useContactsStore((state) => state.searchActive);
  const setSearchActive = useContactsStore((state) => state.setSearchActive);

  useEffect(() => {
    setSearchActive(false);
  }, []);

  const handleSearch = async (
    event: CustomEvent<{ value?: string | null | undefined }>
  ) => {
    setSearchActive(true);
    const updatedFilters = filters.map((filter) => {
      if (filter.label === "search") {
        return {
          ...filter,
          isActive:
            event.detail.value === "" || !event.detail.value ? false : true,
          value: event.detail.value || "",
        };
      }
      return filter;
    });
    setFilters(updatedFilters);
  };

  useEffect(() => {
    // set value if exists
    const searchFilter = filters.find(
      (f) => f.label === "search" && f.isActive
    );
    if (searchFilter && searchFilter.value) {
      setSearchActive(true);
    }
  }, [filters]);

  return (
    <IonSearchbar
      ref={searchbarRef}
      className={classNames({
        "search-is-active": searchActive === true,
      })}
      value={filters.find((f) => f.label === "search")?.value as string}
      debounce={750}
      onIonInput={(ev) => handleSearch(ev)}
      placeholder={intl.formatMessage({
        id: "chats.searchContact",
      })}
      mode={`ios`}
      onIonFocus={() => {
        setSearchActive(true);
      }}
      onIonClear={async () => {
        setSearchActive(false);
        const updatedFilters = filters.map((filter) => {
          if (filter.label === "search" && filter.isActive) {
            return {
              ...filter,
              isActive: false,
              value: "",
            };
          }
          return filter;
        });
        setFilters(updatedFilters);
        const inputEl = await searchbarRef.current?.getInputElement();
        inputEl?.blur();
      }}
    />
  );
};

interface ILayoutProps {
  defaultClass: string;
  companies?: Company[];
  actions?: Action[];
}

export default DropdownCheckbox;
